import {isEmpty} from '../../../../utils/util'
import {_validateFail, _validateSuccess} from '../_mapping-helper'

export default {
  data () {
    return {
      messages: {}
    }
  },
  methods: {
    initValidateMessage () {
      const messages = {}
      this.keyMappingEntities.forEach(([key, {tip}]) => {
        messages[key] = tip
      })
      this.messages = messages
    },
    /**
     * @param value
     * @param key
     */
    handleValidate (value, key) {
      const {validate, nullable} = this.keyMappingOriginal[key]
      if (validate) {
        this.messages[key] = validate(value, this.data)
      } else if (!nullable && isEmpty(value)) {
        this.messages[key] = _validateFail('该字段不许为空')
      } else {
        this.messages[key] = _validateSuccess()
      }
    },
    validateBeforePost (data) {
      this.keyMappingEntities.forEach(([key]) => {
        const cv = data[key]
        let sv = data[`_${key}`]
        if (sv) {
          sv = sv._value ? sv._value._value : (sv._value || sv)
        }
        const value = cv || sv
        this.handleValidate(value, key)
      })

      const hasNotSuccess = () => {
        const index = Object.values(this.messages).findIndex(({success}) => !success)
        return index >= 0
      }
      return !hasNotSuccess()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/pages/di-ding-validate-mixin.js